export const infoSources = {
    state: {
        infoSources: []
    },
    mutations: {
        SET_INFOSOURCES(state, infoSources) {
            state.infoSources = infoSources
        }
    },
    actions: {
        fetchInfoSources({ commit, getters }) {
            return this.$api.get('b2b/v2/management/info_sources').then(response => {
                commit('SET_INFOSOURCES', response.data.data)
                return Promise.resolve()
            }).catch(error => {
                return Promise.reject(new Error(error))
            })
        }
    },
    getters: {
        infoSources: state => state.infoSources
    }
}
